module.exports = __webpack_public_path__ + "static/media/swift.50d0c46c.png";